<template>
  <div class="dashboard-container after-loop">
    <h3>Dashboard</h3>
    <p>Welcome {{ user.currentUser.name }}</p>
    <el-row>
      <el-col :lg="12" :md="24" :sm="24" style="text-align: right">
        <el-image :src="image2" fit="scale-down" style="width: 40vw; text-align: center">
          <div slot="placeholder" class="image-slot" style="padding-top: 40%">
            <span class="dot"><i class="el-icon-loading"/></span>
          </div>
        </el-image>
      </el-col>
      <el-col :lg="12" :md="24" :sm="24">
        <el-image :src="image1" fit="scale-down" style="width: 40vw; text-align: center">
          <div slot="placeholder" class="image-slot" style="padding-top: 40%">
            <span class="dot"><i class="el-icon-loading"/></span>
          </div>
        </el-image>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Dashboard',
  data() {
    return {
      image1: 'QPS.jpg',
      srcList1: [
        'QPS.jpg'
      ],
      image2: 'VSUV.jpg',
      srcList2: [
        'VSUV.jpg'
      ],
      applicant: null,
      meta: {},
      isRSPMeber: false,
      isUser: false
    }
  },
  computed: {
    ...mapGetters([
      'username',
      'firstname',
      'lastname',
      'user'
    ])
  },
  created() {
  },
  methods: {

  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin-right: 10px;
    margin-left: 10px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
@import '../../styles/z-theme.css';

.i-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 4rem;
  left: 1rem;
  color: rgba(255,255,255,.2);
  transition: .15s all ease;
}
.after-loop .card {
  margin-bottom: 10px;
}
.dark-green-bg{
  background-color: #136d27 !important;
}
</style>
